import React, { useEffect, useState, useRef } from "react";
// import { useSelector } from "react-redux";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import "sweetalert2/dist/sweetalert2.min.css";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";
import HeaderModule from "../../components/Header/HeaderModule";
import { dateFormat } from "../../common/common";
import { Box } from "@mui/material";
import { Modal } from "react-bootstrap";
import { Eye } from "feather-icons-react/build/IconComponents";
// import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
// import { all_routes } from "../../../Router/all_routes";
// import { useCheckUserPermission } from "../../common/userPermission";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const BusinessAppoiment = () => {
  const param = useParams();
  // const navigate = useNavigate();
  // const user_data = useSelector((state) => state.user_data);

  // const route = all_routes;

  // Default: last 2 months to today
  const defaultStart = moment().subtract(2, "months").toDate();
  const defaultEnd = new Date();

  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);

  const [formattedStart, setFormattedStart] = useState(
    moment(defaultStart).format("YYYY-MM-DD")
  );
  const [formattedEnd, setFormattedEnd] = useState(
    moment(defaultEnd).format("YYYY-MM-DD")
  );

  const [productlist, setProductlist] = useState([]);
  const [appintmentServiceData, setAppintmentServiceData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [filterAppointmentID, setFilterAppointmentID] = useState(0);

  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedBusinessId, setSelectedBusinessId] = useState(0);
  const [selectedBusinessName, setSelectedBusinessName] = useState("");

  const wrapperRef = useRef(null);

  console.log(suggestions, "suggestions12121");

  const handleSearch = async (value) => {
    setQuery(value);

    if (value.trim().length === 0) {
      setSuggestions([]);
      return;
    }

    try {
      const response = await apiHandler({
        method: "POST",
        route: "Business/GetBusinessSearch",
        payload: { query: value },
      });

      if (response.ResponseCode === "SUCCESS") {
        // Extract first resultset (list of rows)
        const data = response.ResponseData?.[0] || [];
        setSuggestions(data);
      } else {
        setSuggestions([]);
      }
    } catch (err) {
      console.error("Search API error:", err);
    }
  };

  // Close suggestions when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setSuggestions([]);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleSelect = (item) => {
    setSelectedBusinessId(item.ID);
    setSelectedBusinessName(item.businessName);
    setQuery(item.businessName);
    setSuggestions([]);
  };

  // Format date for backend
  const formatDate = (date) => {
    if (!date) return "";
    return moment(date).format("YYYY-MM-DD");
  };

  const prodcutDataListApi = async () => {
    setLoading(true);
    const response = await apiHandler({
      method: "GET",
      route: `Business/getAllBusinessAppointment?BusinessID=${selectedBusinessId}&startDate=${formattedStart}&endDate=${formattedEnd}`,
    });

    if (response.ResponseCode === "SUCCESS") {
      setProductlist(response.ResponseData?.Appointments || []);
      setAppintmentServiceData(
        response.ResponseData?.AppointmentsServices || []
      );
    }
    setLoading(false);
  };

  /** ================================
   * 📌 INITIAL LOAD + DATE CHANGE REFRESH
   * ==================================
   */
  useEffect(() => {
    prodcutDataListApi();
  }, []);

  useEffect(() => {
    prodcutDataListApi();
  }, [formattedStart, formattedEnd, selectedBusinessName]);

  /** ================================
   * 📌 CHECK PARAM ID FROM URL
   * ==================================
   */
  useEffect(() => {
    if (param?.id > 0) {
      setFilterAppointmentID(Number(param.id));
      setShowModal(true);
    }
  }, [param?.id]);

  /** ================================
   * 📌 PHONE NUMBER FORMAT
   * ==================================
   */
  const formatDBPhoneNumber = (number) => {
    if (!number) return "";
    let cleaned = number.replace(/\D/g, "");
    if (cleaned.startsWith("61")) cleaned = "+" + cleaned;
    else if (cleaned.startsWith("0")) cleaned = "+61" + cleaned.substring(1);
    else if (!cleaned.startsWith("+61")) cleaned = "+61" + cleaned;
    const noPlus = cleaned.replace("+", "");
    return "+" + noPlus.replace(/^61(\d)(\d{4})(\d{4})$/, "61 $1 $2 $3");
  };

  /** ================================
   * 📌 CANCEL APPOINTMENT
   * ==================================
   */
  // const handelCancelAppointment = async (appointmentId) => {
  //   const confirmCancel = await Swal.fire({
  //     title: "Cancel Appointment",
  //     input: "textarea",
  //     inputLabel: "Reason for cancellation",
  //     showCancelButton: true,
  //   });

  //   if (confirmCancel.isConfirmed) {
  //     setLoading(true);
  //     const response = await apiHandler({
  //       method: "POST",
  //       route: `Business/cancelappointment`,
  //       payload: {
  //         appointmentId: appointmentId,
  //         cancellationMessage: confirmCancel?.value || "",
  //       },
  //     });

  //     if (response.ResponseCode === "SUCCESS") {
  //       prodcutDataListApi();
  //     }
  //     setLoading(false);
  //   }
  // };

  /** ================================
   * 📌 TABLE COLUMNS
   * ==================================
   */
  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      sortingFn: "numeric",
      size: 100,
    },
    {
      header: "Business Name",
      accessorKey: "businessUniqueName",
       enableGrouping: true,
    },
    {
      header: "Scheduled Date",
      accessorKey: "Date",
      Cell: ({ row }) => (
        <div>{row.original.Date ? dateFormat(row.original.Date) : "-"}</div>
      ),
    },
    {
      header: "Created Date",
      accessorKey: "createdAt",
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          <span>
            {row.original.createdAt ? dateFormat(row.original.createdAt) : "-"}
          </span>
          <span>{row.original.startTime || ""}</span>
        </div>
      ),
    },
    {
      header: "IsGroup",
      accessorKey: "IsGroup",
      Cell: ({ row }) => (row.original.IsGroup == 1 ? "YES" : "NO"),
    },
    {
      header: "Customer Name",
      accessorKey: "customerName",
    },
    {
      header: "Customer Email",
      accessorKey: "customerEmail",
    },
    {
      header: "Customer Number",
      accessorKey: "customerNumber",
      Cell: ({ cell }) => formatDBPhoneNumber(cell.getValue()),
    },
    {
      header: "Payment Status",
      accessorKey: "paymentStatus",
      Cell: ({ row }) => (
        <span>
          {row.original.paymentStatus?.toLowerCase() === "paid"
            ? "Paid"
            : "Pay At Venue"}
        </span>
      ),
    },
    {
      header: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          {/* {useCheckUserPermission(route.BusinessOnboarding) && (
            <button
              className="btn btn-outline-primary btn-sm me-2"
              onClick={() =>
                navigate(`/bookingCalendar/${row.original.ID}`)
              }
            >
              <Edit className="custome-icon-size" />
            </button>
          )} */}

          <button
            className="btn btn-outline-primary btn-sm me-2"
            onClick={() => {
              setFilterAppointmentID(row.original.ID);
              setShowModal(true);
            }}
          >
            <Eye className="custome-icon-size" />
          </button>

          {/* <button
            className="btn btn-primary btn-sm"
            onClick={() => handelCancelAppointment(row.original.ID)}
          >
            <Trash2 className="custome-icon-size" />
          </button> */}
        </Box>
      ),
    },
  ];

  /** ================================
   * 📌 EXPORT DATA
   * ==================================
   */
  const exportData = productlist?.map((item) => ({
    ID: item?.ID,
    BusinessName: item?.businessUniqueName,
    ["Scheduled Date"]: dateFormat(item?.Date),
    ["Created Date"]: dateFormat(item?.createdAt),
    IsGroup: item?.IsGroup == 1 ? "YES" : "NO",
    ["Customer Name"]: item?.customerName,
    ["Customer Email"]: item?.customerEmail,
    ["Customer Number"]: item?.customerNumber,
    ["Service Data"]: appintmentServiceData
      ?.filter((el) => el.appointmentId === item.ID)
      ?.map((service) => service.serviceName)
      .join(", "),
  }));

  /** ================================
   * 📌 MODAL SERVICE LIST
   * ==================================
   */
  const selectedServices = appintmentServiceData.filter(
    (s) => s.appointmentId === filterAppointmentID
  );
  const modalCommon = selectedServices[0];

  /* common style class */
  //  const CUSTOM_SELECT_DROPDOWN_STYLE = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     // height: "40px",
  //     position: "relative",
  //     border: state.isFocused
  //       ? "1px solid var(--primary-main-color)"
  //       : "1px solid var(--primary-color-100)", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     '&:hover': {
  //       border: state.isFocused
  //         ? "1px solid var(--primary-main-color)"
  //         : "1px solid var(--primary-color-100)", // add orange outline when hovering
  //     },
  //     borderRadius: "var(--border-radius) !important",
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 var(--primary-color-50)",
  //     position: "absolute",
  //     'z-index': "99999",
  //     background: "var(--primary-color-50)",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     color: state.isSelected
  //       ? "var(--primary-base-color)"
  //       : "var(--primary-color-800)",
  //     backgroundColor: state.isFocused
  //       ? "var(--primary-color-50)"
  //       : state.isSelected
  //       ? "var(--primary-color-50)"
  //       : "var(--primary-base-color)", // change hover color to light orange
  //     '&:hover': {
  //       backgroundColor: "var(--primary-color-50)", // change hover color to light orange
  //     },
  //   }),
  // };
  return (
    <>
      <LoadingSpinner isLoading={loading} />

      <div className="page-wrapper">
        <div className="content">
          <HeaderModule
            refreshData={prodcutDataListApi}
            exportData={exportData}
          />

          {/* ==================== DATE PICKER ==================== */}
         <div className="row mb-4" style={{ position: "relative", zIndex: 9 }}>
  {/* =========================
       ROW 1 → BUSINESS SEARCH
     ========================= */}
  <div className="col-md-5 position-relative" ref={wrapperRef}>
    <label className="form-label mr-2">Business :</label>

    <input
      type="text"
      className="form-control"
      placeholder="Search Business"
      value={query}
      onChange={(e) => handleSearch(e.target.value)}
    />

    {/* Suggestions */}
    {suggestions.length > 0 && (
      <div
        className="list-group"
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          width: "100%",
          maxHeight: "250px",
          overflowY: "auto",
          zIndex: 9999,
          boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
          background: "#fff",
          borderRadius: "4px",
        }}
      >
        {suggestions.map((item) => (
          <button
            key={item.ID}
            type="button"
            className="list-group-item list-group-item-action"
            onClick={() => handleSelect(item)}
          >
            {item.businessName}
          </button>
        ))}
      </div>
    )}
  </div>
</div>

{/* =========================
     ROW 2 → DATE PICKERS
   ========================= */}
<div style={{position:"relative" , zIndex:"999999999"}} className="row mb-4">

  {/* START DATE */}
  <div className="col-md-3">
    <label className="form-label mr-2">Start Date:</label>
    <DatePicker
      selected={startDate}
      onChange={(date) => {
        setStartDate(date);
        setFormattedStart(formatDate(date));
      }}
      dateFormat="dd/MM/yyyy"
      className="form-control"
      maxDate={endDate}
    />
  </div>

  {/* END DATE */}
  <div className="col-md-3">
    <label className="form-label mr-2">End Date:</label>
    <DatePicker
      selected={endDate}
      onChange={(date) => {
        setEndDate(date);
        setFormattedEnd(formatDate(date));
      }}
      dateFormat="dd/MM/yyyy"
      className="form-control"
      minDate={startDate}
    />
  </div>

</div>


          <div style={{position:"relative", zIndex:"99"}} className="card table-list-card">
            <div className="card-body">
              <CommonMaterialReactTable
                columns={columns}
                data={productlist}
                columnRightPin={["actions"]}
                enableGrouping = {true}
              />
            </div>
          </div>
        </div>
      </div>

      {/* ========================== MODAL ========================== */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Service Details – Appointment {filterAppointmentID}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedServices.length > 0 ? (
            <div>
              <p>
                <strong>Name:</strong> {modalCommon.customerName}
              </p>
              <p>
                <strong>Phone:</strong>{" "}
                {formatDBPhoneNumber(modalCommon.customerNumber)}
              </p>
              <p>
                <strong>Time:</strong>{" "}
                {moment(modalCommon.Date).format("dd/MM/yyyy")} –{" "}
                {modalCommon.startTime}
              </p>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Service</th>
                    <th>Duration</th>
                    <th>Member</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedServices.map((s) => (
                    <tr key={s.appointmentdetileId}>
                      <td>{s.serviceName}</td>
                      <td>{s.serviceduration}</td>
                      <td>{s.teamName || "Any Professional"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div>No services found.</div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BusinessAppoiment;
